/* eslint-disable max-lines */
/* eslint-disable extra-rules/no-commented-out-code */
// 9fbef606107a605d69c0edbcd8029e5d
import {
  call,
  takeLatest,
  put,
  all,
  select,
  takeEvery,
  takeLeading,
  fork,
} from 'redux-saga/effects';
import logger from '@tcp/core/src/utils/loggerInstance';
import { formValueSelector, change } from 'redux-form';
import verifyAddressData from '@tcp/core/src/services/abstractors/account/AddressVerification';
import { trackFormError } from '@tcp/core/src/analytics/actions';
import setLoaderState from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import {
  getEddData,
  resetEddData,
} from '@tcp/core/src/components/features/CnC/common/molecules/EddComponent/container/EddComponent.actions';
import { setLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import { getAppleClientTokenData } from '@tcp/core/src/components/features/CnC/Checkout/container/CheckoutApple.selector.js';
import { getCurrencyAttributes } from '@tcp/core/src/reduxStore/selectors/currency.selectors';
import isEmpty from 'lodash/isEmpty';
import BagPageActions from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.actions';
import {
  getIsExtendedPreOrderForSPC,
  getPaymentId,
  getSfsError,
} from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.selector';
import { isApplePayEligible, parseBoolean } from '@tcp/core/src/utils/utils';
import isAppleWalletSetUp from './applepay.utils';
import {
  getDefaultShipmentTTL,
  getIsInternationalShipping,
  getIsDefaultApplePayAbTest,
  getRefreshCouponOnSubmitShipping,
  getIsInternationalPhoneNumber,
  getSMSUpdatesSingleOptInEnabled,
} from '../../../../../reduxStore/selectors/session.selectors';
import {
  getInternationCheckoutSettings,
  startEddPersist,
  startExpressCheckout,
} from '../../../../../services/abstractors/CnC/Checkout';
import {
  getShippingMethods,
  setSMSUpdates,
  updateGiftServices,
  getTransSmsStatus,
} from '../../../../../services/abstractors/CnC/CheckoutSFCC';
import {
  getSiteIdInCaps,
  isCanada,
  getSessionStorage,
  removeSessionStorage,
} from '../../../../../utils';
import { verifyAddress } from '../../../../common/organisms/AddressVerification/container/AddressVerification.actions';
import { getAddressList } from '../../../account/AddressBook/container/AddressBook.saga';
import { getAddressListState } from '../../../account/AddressBook/container/AddressBook.selectors';
import { openOverlayModal } from '../../../account/OverlayModal/container/OverlayModal.actions';
import { getCardList } from '../../../account/Payment/container/Payment.saga';
import { isRememberedUser } from '../../../account/User/container/User.selectors';
import BAG_PAGE_ACTIONS from '../../BagPage/container/BagPage.actions';
import {
  getCartDataSaga,
  processMutationNonCachedDataSaga,
} from '../../BagPage/container/BagPage.saga';
import BagPageSelectors, { getOrderType } from '../../BagPage/container/BagPage.selectors';
import CONSTANTS, {
  CHECKOUT_ROUTES,
  DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY,
} from '../Checkout.constants';
import utility from '../util/utility';
import CHECKOUT_ACTIONS, {
  getSetBillingValuesActn,
  getSetPickupAltValuesActn,
  getSetPickupValuesActn,
  getSetShippingValuesActn,
  setAddressError,
  setInitCheckoutFinished,
  setIsLoadingShippingMethods,
  setIsUpdatingShipmentMethods,
  setShippingOptions,
  setSMSUpdatesActn,
  toggleZipCodeLoader,
} from './Checkout.action';
import {
  addNewShippingAddress,
  callPickupSubmitMethod,
  callUpdateRTPS,
  createGitOptionRequestDTO,
  createShippingAddressRequestDTO,
  getAppleClientTokenSaga,
  getShippingEventType,
  getVenmoClientTokenSaga,
  handleCheckoutInitRouting,
  makeUpdateRTPSCall,
  redirectFromExpress,
  routeToPickupPage,
  saveLocalSmsInfo,
  shouldInvokeReviewCartCall,
  submitAcceptOrDeclinePlccData,
  updateShipmentMethodSelection,
  updateShipping,
  updateShippingAddress,
} from './Checkout.saga.util';
import { getGiftWrapOptionsData, handleServerSideErrorAPI } from './CheckoutCommon.saga';
import selectors, {
  getLoginV2FlowEnabled,
  getPickupValues,
  isExpressCheckout,
  isGuest,
} from './Checkout.selector';
import submitBilling, {
  submitAppleBilling,
  submitVenmoBilling,
  updateCardDetails,
  submitAfterPayOnBilling,
  checkoutWithAfterPay,
  checkoutWithExpressAfterPay,
} from './CheckoutBilling.saga';
import { pickUpRouting, submitEmailSignup } from './CheckoutExtended.saga.util';
import submitOrderForProcessing from './CheckoutReview.saga';
import { submitShippingSectionData, submitVerifiedAddressData } from './CheckoutShipping.saga';
import { fetchPaySecureSessionIdSaga } from './CheckoutBilling.saga.util';
import {
  recalibrateSectionStates,
  setSpcButtonLoader,
  setShowAddressVerification,
  setSFSErrors,
} from '../../SinglePageCheckout/container/SinglePageCheckout.actions';
import {
  addPerformanceMarksForSection,
  setAfterPayPaymentmethod,
} from '../../SinglePageCheckout/container/SinglePageCheckout.saga.util';
import { BILLING_FORM_VISIBLE } from '../../../../../constants/rum.constants';
import { checkDefaultAfterPayEnabled } from '../../SinglePageCheckout/container/SinglePageCheckout.selector';
import { setServerErrorCheckout } from './Checkout.action.util';
import { readCookie, setCookie } from '../../../../../utils/cookie.util';

const {
  getIsOrderHasShipping,
  getShippingDestinationValues,
  getGiftServicesFormData,
  getShipmentMethods,
  getCurrentCheckoutStage,
  getIfRedirectFromExpress,
  getShippingAddressList,
  getBillingValues,
} = selectors;
const { hasPOBox } = utility;
let oldHasPOB = {};

const checkUpdateShippingRequiredFields = (updateShippingRequestDto) => {
  return (
    updateShippingRequestDto?.shippingAddressDTO?.shippingAddress.address1 !== ' ' &&
    updateShippingRequestDto?.shippingAddressDTO?.shippingAddress?.c_emailAddress !== '' &&
    updateShippingRequestDto?.shippingAddressDTO?.shippingAddress?.phone !== ''
  );
};

function* storeUpdatedCheckoutValues(res /* isCartNotRequired, updateSmsInfo = true */) {
  // setCartInfo(cartInfo, isSetCartItems, shouldExportActions)
  const resCheckoutValues = res.payload.res.orderDetails.checkout;
  const actions = [];
  if (
    !isEmpty(resCheckoutValues.pickUpContact) &&
    (resCheckoutValues.pickUpContact.firstName !== DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.firstName ||
      resCheckoutValues.pickUpContact.lastName !== DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.lastName)
  ) {
    actions.push(getSetPickupValuesActn(resCheckoutValues.pickUpContact));
  }
  if (!isEmpty(resCheckoutValues.pickUpAlternative)) {
    actions.push(getSetPickupAltValuesActn(resCheckoutValues.pickUpAlternative));
  }
  if (
    resCheckoutValues.shipping &&
    !resCheckoutValues.shipping.noReduxUpdate &&
    (resCheckoutValues.shipping.addressLine1 !== DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.address1 ||
      resCheckoutValues.shipping.phoneNumber !== DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.phone ||
      resCheckoutValues.shipping.emailAddress !== DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.email)
  ) {
    actions.push(getSetShippingValuesActn(resCheckoutValues.shipping));
  }
  if (resCheckoutValues.giftWrap) {
    actions.push(
      CHECKOUT_ACTIONS.getSetGiftWrapValuesActn({
        hasGiftWrapping: !!resCheckoutValues.giftWrap.optionId,
        ...resCheckoutValues.giftWrap,
      })
    );
  }
  if (resCheckoutValues.billing && !resCheckoutValues.billing.noReduxUpdate) {
    actions.push(getSetBillingValuesActn(resCheckoutValues.billing));
  }
  // resCheckoutValues.smsInfo && updateSmsInfo &&
  //   setSmsNumberForUpdates(resCheckoutValues.smsInfo.numberForUpdates),
  yield all(actions.map((action) => put(action)));
  // if (checkoutStoreView.isExpressCheckout(this.store.getState()) && resCheckoutValues.billing && resCheckoutValues.billing.paymentMethod === 'venmo') {
  //   // We have
  //   this.store.dispatch(setVenmoPaymentInProgress(true));
  // }
}

function* submitPickupSection({ payload }) {
  try {
    const formData = { ...payload };
    const isGuestUser = yield select(isGuest);
    const getIsShippingRequired = yield select(getIsOrderHasShipping);
    if (formData.pickUpContact.smsInfo) yield saveLocalSmsInfo(formData.pickUpContact.smsInfo);
    yield put(setLoaderState(true));
    yield submitEmailSignup(formData.pickUpContact.emailAddress, formData);
    const result = yield call(callPickupSubmitMethod, formData);

    if (result.addressId) {
      if (!isGuestUser && !getIsShippingRequired) {
        yield call(getCardList, { ignoreCache: true });
      }
      const isVenmoInProgress = yield select(selectors.isVenmoPaymentInProgress);
      const isVenmoPickupDisplayed = yield select(selectors.isVenmoPickupBannerDisplayed);
      pickUpRouting({ getIsShippingRequired, isVenmoInProgress, isVenmoPickupDisplayed });
    }
    /* In the future I imagine us sending the SMS to backend for them to
        store so it will be loaded in the below loadUpdatedCheckoutValues function.
        for now we are storing it only on browser so will lose this info on page re-load.
      */
    // eslint-disable-next-line no-unused-expressions
    // return getCheckoutOperator(this.store).loadUpdatedCheckoutValues(false, true, true, false, !wantsSmsOrderUpdates);
    // }).catch((err) => {
    //   throw getSubmissionError(this.store, 'submitPickupSection', err);
    // });
    yield put(setLoaderState(false));
  } catch (e) {
    const { pickUpContact } = payload;
    const { firstName, phoneNumber, emailAddress, lastName, smsInfo } = pickUpContact;
    const { smsUpdateNumber } = smsInfo;
    const requiredList3Val = { smsUpdateNumber, firstName, phoneNumber, emailAddress, lastName };
    yield put(trackFormError({ formName: 'checkoutPickup', formData: requiredList3Val }));

    yield put(setLoaderState(false));

    yield call(handleServerSideErrorAPI, e);
  }
}
// function setCartInfo(cartInfo, isSetCartItems) {
//   return updateCartInfo(cartInfo, isSetCartItems);
// }
export function* loadShipmentMethods(miniAddress, loadPageEvent = false) {
  let address;
  let pageEvent = loadPageEvent;
  if (miniAddress.formName) {
    const addressSelector = formValueSelector(miniAddress.formName);
    const addressValues = yield select(addressSelector, 'address');
    address = {
      ...addressValues,
      zipCode: miniAddress.zipCode || addressValues?.zipCode,
      addressField1: miniAddress.addressField1 || addressValues?.addressField1,
      addressField2: miniAddress.addressField2 || addressValues?.addressField2,
      state: miniAddress.state || addressValues?.state,
    };
  } else if (miniAddress.isCancelClicked) {
    const shippingAddress = yield select(getShippingDestinationValues);
    ({ address } = shippingAddress);
  } else {
    address = miniAddress;
  }

  if (miniAddress.payload && miniAddress.payload.pageEvent) {
    const { pageEvent: event } = miniAddress.payload;
    pageEvent = event;
  }
  if (miniAddress?.payload) {
    const { address1, address2, postalCode, stateCode } = miniAddress.payload;
    address = {
      zipCode: postalCode,
      addressField1: address1,
      addressField2: address2,
      state: stateCode,
    };
  }

  try {
    const labels = yield select(BagPageSelectors.getErrorMapping);
    yield put(setIsLoadingShippingMethods(true));
    const isShipmentMethodCached = yield select(selectors.getDefaultShipmentMethods);
    const userAddresses = yield select(getAddressListState);
    const storedShippingAddress = yield select(getShippingDestinationValues);
    const shipmentAddress = address || storedShippingAddress.address;
    const eventType = getShippingEventType(
      pageEvent,
      isShipmentMethodCached,
      userAddresses,
      shipmentAddress
    );
    const cacheTTL = yield select(getDefaultShipmentTTL);
    // Backend for Canada needs ZipCode and addressField1 in headers for change shipment.
    const res = yield getShippingMethods(address, labels, eventType, cacheTTL);
    yield all([setShippingOptions(res), setIsLoadingShippingMethods(false)].map((val) => put(val)));
  } catch (err) {
    yield put(setIsLoadingShippingMethods(false));
  }
}

function* validDateAndLoadShipmentMethods(miniAddress, changhedFlags) {
  // Note: this convoluted logic is due to BE. If address lines do not contain a pobox
  // then in the US we should only respond to state changes, and in Canada only to
  // zipcode changes. And we also have to react to any change if switching from having
  // to not having a pobox, or a change in address lines if currently has a pobox
  const newHasPOB = hasPOBox(miniAddress.addressLine1, miniAddress.addressLine2);
  if (
    !(
      oldHasPOB !== newHasPOB ||
      (newHasPOB && (changhedFlags.addressLine1 || changhedFlags.addressLine2))
    ) &&
    // zipCode changed, but not state
    ((miniAddress.country === 'US' && !changhedFlags.state) ||
      // state changed, but not zipCode
      (miniAddress.country === 'CA' && !changhedFlags.zipCode))
  ) {
    // shipping methods are the same as we already have
    return yield;
  }
  oldHasPOB = newHasPOB;
  return yield loadShipmentMethods(miniAddress, true);
}

const makeShipmentMethodsCall = ({ shipmentMethods, makeCartApiCall }) =>
  makeCartApiCall || !shipmentMethods.length;

const getShipmentAddress = (shippingAddress = {}, defaultShipping = {}) => {
  const { addressLine1, addressLine2, state, zipCode, country } = shippingAddress;
  const {
    addressLine = [],
    country: defaultCountry = '',
    state: defaultState = '',
    zipCode: defaultZipCode = '',
  } = defaultShipping;
  return {
    addressField1: addressLine1 || addressLine[0],
    addressField2: addressLine2 || addressLine[1],
    country: country || defaultCountry,
    state: state || defaultState,
    zipCode: zipCode || defaultZipCode,
  };
};

function* initShippingData(pageName, makeCartApiCall) {
  const shipmentMethods = yield select(getShipmentMethods);
  if (pageName === CONSTANTS.CHECKOUT_STAGES.SHIPPING) {
    yield call(getGiftWrapOptionsData);
    if (makeShipmentMethodsCall({ shipmentMethods, makeCartApiCall })) {
      let shippingAddress = yield select(getShippingDestinationValues);
      shippingAddress = shippingAddress.address;

      const hasShipping =
        shippingAddress &&
        shippingAddress.country &&
        shippingAddress.state &&
        shippingAddress.zipCode;
      const isGuestUser = yield select(isGuest);
      if (isGuestUser || !hasShipping || !shipmentMethods.size) {
        const shippingAddressBook = yield select(getShippingAddressList);
        const defaultShipping = shippingAddressBook.find(
          (address) => address && address.preferred === 'true'
        );
        const address = getShipmentAddress(shippingAddress, defaultShipping);
        yield call(validDateAndLoadShipmentMethods, address, { state: true, zipCode: true });
      }
    }
  }
}

function* triggerInternationalCheckoutIfRequired() {
  const isInternationalShipping = yield select(getIsInternationalShipping);
  if (isInternationalShipping) {
    return utility.routeToPage(CHECKOUT_ROUTES.internationalCheckout);
  }
  return null;
}

function* getPaypayExpressDataIfRequired({ pageName, isPaypalPostBack, isNonExpressCheckout }) {
  const { REVIEW } = CONSTANTS.CHECKOUT_STAGES;
  if (isNonExpressCheckout && isPaypalPostBack && pageName === REVIEW) {
    const shippingValues = yield select(getShippingDestinationValues);
    const shippingAddress = (shippingValues && shippingValues.address) || {};
    yield validDateAndLoadShipmentMethods(
      {
        country: shippingAddress.country || '',
        state: shippingAddress.state || '',
        zipCode: shippingAddress.zipCode || '',
      },
      { state: true, zipCode: true }
    );
  }
}

export function* validateAdress(
  isPaypalPostBack,
  shippingValues,
  isExpressCheckoutEnabled,
  pageName
) {
  const checkoutDetails = yield select(getBillingValues);
  const { billing } = checkoutDetails || {};
  const { cardType } = billing || {};
  const applePayOnReview =
    cardType === CONSTANTS.APPLEPAY_LABEL && pageName === CONSTANTS.CHECKOUT_STAGES.REVIEW;
  if (shippingValues && (isExpressCheckoutEnabled || isPaypalPostBack || applePayOnReview)) {
    const shippingAddress = shippingValues.address || {};
    const {
      addressLine1: address1,
      addressLine2: address2,
      zipCode: zip,
      state,
      city,
      country,
      firstName,
      lastName,
    } = shippingAddress;
    if (!address1) {
      return false;
    }
    return yield put(
      verifyAddress({
        address1,
        address2,
        zip,
        state,
        city,
        country,
        firstName,
        lastName,
        doNotShowLoader: pageName === CONSTANTS.CHECKOUT_STAGES.REVIEW,
      })
    );
  }
  return false;
}

function* initCheckoutSectionData({ payload }) {
  const { pageName, isPaypalPostBack, appRouting, navigation } = payload;
  yield call(triggerInternationalCheckoutIfRequired);
  const isExpressCheckoutEnabled = yield select(isExpressCheckout);
  const currentStage = yield select(getCurrentCheckoutStage);
  const ifRedirectFromExpress = yield select(getIfRedirectFromExpress);
  const cartItems = yield select(BagPageSelectors.getOrderItems);
  const availableStages = utility.getAvailableStages(cartItems);
  const { PICKUP, SHIPPING, BILLING } = CONSTANTS.CHECKOUT_STAGES;
  const pendingPromises = [];
  const isNonExpressCheckout = shouldInvokeReviewCartCall(isExpressCheckoutEnabled, payload);
  let makeCartApiCall = false;
  if (pageName === PICKUP || pageName === BILLING || pageName === SHIPPING) {
    makeCartApiCall =
      availableStages.indexOf(pageName.toLowerCase()) >=
      availableStages.indexOf(currentStage.toLowerCase());

    if (ifRedirectFromExpress) makeCartApiCall = true;

    if (!appRouting && makeCartApiCall) {
      pendingPromises.push(put(BAG_PAGE_ACTIONS.getCachedCartData({})));
      pendingPromises.push(put(BAG_PAGE_ACTIONS.getNonCachedCartData({ isCheckoutFlow: true })));
    }
  } else if (isNonExpressCheckout) {
    pendingPromises.push(put(BAG_PAGE_ACTIONS.getCachedCartData({})));
    pendingPromises.push(put(BAG_PAGE_ACTIONS.getNonCachedCartData({ isCheckoutFlow: true })));
  }

  yield all(pendingPromises);
  yield call(getPaypayExpressDataIfRequired, {
    pageName,
    isPaypalPostBack,
    isExpressCheckoutEnabled,
    isNonExpressCheckout,
  });
  const requestedStage = yield call(handleCheckoutInitRouting, { pageName }, appRouting);
  yield call(initShippingData, requestedStage, makeCartApiCall);
  const isVenmoInProgress = yield select(selectors.isVenmoPaymentInProgress);
  if (makeUpdateRTPSCall(pageName, isPaypalPostBack, isExpressCheckoutEnabled, isVenmoInProgress)) {
    yield call(callUpdateRTPS, pageName, navigation, isPaypalPostBack, isVenmoInProgress);
  }
  const shippingValues = yield select(getShippingDestinationValues);
  yield call(validateAdress, isPaypalPostBack, shippingValues, false, pageName);
}

function* triggerExpressCheckout(
  section,
  navigation,
  isPaypalPostBack,
  shouldPreScreenUser = false,
  source = null
) {
  try {
    const pageName = section;
    yield put(BAG_PAGE_ACTIONS.setBagPageLoading());

    yield put(BAG_PAGE_ACTIONS.setCartSupressOnBagUpdate(false));
    const isVenmoInProgress = yield select(selectors.isVenmoPaymentInProgress);
    const res = yield startExpressCheckout(shouldPreScreenUser, source);
    if (!res.orderId) {
      return yield redirectFromExpress();
    }
    yield call(getAddressList);
    yield call(getCartDataSaga, {
      payload: {
        isRecalculateTaxes: true,
        excludeCartItems: false,
        recalcRewards: true,
        isCheckoutFlow: true,
        translation: true,
      },
    });
    if (!isPaypalPostBack) {
      yield call(callUpdateRTPS, pageName, navigation, isPaypalPostBack, isVenmoInProgress);
    }
    const shippingValues = yield select(getShippingDestinationValues);
    const shippingAddress = (shippingValues && shippingValues.address) || {};
    const isExpressCheckoutEnabled = yield select(isExpressCheckout);
    yield call(validateAdress, false, shippingValues, isExpressCheckoutEnabled, pageName);
    return yield validDateAndLoadShipmentMethods(
      {
        country: shippingAddress.country || '',
        state: shippingAddress.state || '',
        zipCode: shippingAddress.zipCode || '',
      },
      { state: true, zipCode: true }
    );
  } catch (e) {
    return yield redirectFromExpress();
  }
}

function* loadExpressCheckout(section, navigation, isPaypalPostBack) {
  //    On shipping we taking into acocunt if this is a gift or not.
  //    On express checkout we pre-screen no matter what,
  //    even though the user may have a gift order
  // const isPreScreenEnabled = yield select(selectors.getIsPreScreenEnabled);
  // const isUserPlcc = yield select(isPlccUser);
  // const shouldPreScreenUser = false;
  // const shouldPreScreenUser = isPreScreenEnabled && !isUserPlcc;
  //     let source = null;
  //     if (checkoutStoreView.isVenmoPaymentInProgress(this.store.getState())) {
  //       source = 'venmo';
  //     }
  yield call(triggerExpressCheckout, section, navigation, isPaypalPostBack);
}

function* loadStartupData(isPaypalPostBack, isRecalcRewards, section, navigation /* isVenmo */) {
  const isExpressCheckoutEnabled = yield select(isExpressCheckout);
  const isAppleInProgress = yield select(selectors.isApplePaymentInProgress);
  const isGuestUser = yield select(isGuest);
  const isRemembered = yield select(isRememberedUser);
  const pendingPromises = [];
  if (!isPaypalPostBack && isExpressCheckoutEnabled && !isAppleInProgress) {
    pendingPromises.push(call(loadExpressCheckout, section, navigation, isPaypalPostBack));
  } else if (!isGuestUser) {
    pendingPromises.push(call(getAddressList));
  }

  // DRP-974: If the user is a remembered user, we are redirecting him/her to the home page and open the login modal
  // else we are continuing.
  if (isRemembered) {
    utility.routeToPage(CHECKOUT_ROUTES.home);
    yield put(
      openOverlayModal({
        component: 'login',
        variation: 'primary',
      })
    );
  } else {
    yield all(pendingPromises);
  }
}

function* initCheckout({ router, navigation }) {
  let isPaypalPostBack;
  let recalc;
  let section;
  if (router && router.query) {
    const { query } = router;
    ({ isPaypalPostBack, recalc, section } = query);
  }
  try {
    yield call(loadStartupData, isPaypalPostBack, recalc, section, navigation);
    yield put(setInitCheckoutFinished(true));
  } catch (e) {
    yield put(setInitCheckoutFinished(true));
    logger.error(e);
  }
}

/**
 * initIntlCheckout component. This is responsible for initiating actions required for start of international checkout journey.
 */
function* initIntlCheckout() {
  try {
    const currencyAttributes = yield select(getCurrencyAttributes);
    const { quoteId } = currencyAttributes || {};
    const res = yield call(getInternationCheckoutSettings, quoteId);
    yield put(CHECKOUT_ACTIONS.getSetIntlUrl(res.checkoutUrl));
  } catch (e) {
    logger.error(`initIntlCheckout:${e}`);
  }
}

function* triggerEddPersist({ payload }) {
  try {
    yield startEddPersist(payload);
  } catch (e) {
    logger.error(`triggerEddPersist:${e}`);
  }
}
function* isWalletSetUp() {
  const appleClientTokenData = yield select(getAppleClientTokenData);
  const { clientToken: authorizationKey } = appleClientTokenData || {};
  const isAppleWalletSetUpVal = yield isAppleWalletSetUp(authorizationKey);

  return isApplePayEligible() && isAppleWalletSetUpVal;
}
function isDefaultApplePayEligible(
  isDefaultApplePayEnabled,
  isExpressCheckoutEnabled,
  billingMethod,
  isDefaultAfterPay,
  walletIsSet,
  isExtendedPreOrderForSpc,
  isPickupSectionSavedForApplePay,
  applePayDefault
) {
  let defaultApple;
  const afterPaySS = parseBoolean(getSessionStorage('defaultAfterPay'));
  if (
    isDefaultApplePayEnabled &&
    !isExpressCheckoutEnabled &&
    !billingMethod &&
    !isDefaultAfterPay &&
    walletIsSet &&
    !isExtendedPreOrderForSpc &&
    isPickupSectionSavedForApplePay &&
    !isCanada() &&
    applePayDefault &&
    !afterPaySS
  ) {
    defaultApple = true;
  } else {
    defaultApple = false;
  }
  return defaultApple;
}
// eslint-disable-next-line sonarjs/cognitive-complexity

export function* setSMSUpdatesSaga(payload) {
  try {
    yield put(setServerErrorCheckout({}));
    const res = yield call(setSMSUpdates, payload);
    yield call(processMutationNonCachedDataSaga, {
      payload: {
        respToProcess: res?.data?.optinOrderUpdates,
        isCheckoutFlow: true,
        ignoreCache: true,
        fromSMSCheckBox: true,
      },
    });
  } catch (error) {
    yield put(setServerErrorCheckout({}));
    const errorMessage = error?.[0]?.errorMessage;
    yield put(setServerErrorCheckout({ errorMessage, component: 'PAGE' }));
  }
}

export function* getTransSmsSubscriptionStateSaga(payloadData) {
  const payloadPhoneNumber = payloadData?.payload ? payloadData?.payload : payloadData;
  const normalizedPhoneNumber = payloadPhoneNumber?.replace(/\D/g, '');
  try {
    yield put(setServerErrorCheckout({}));
    return yield call(getTransSmsStatus, normalizedPhoneNumber);
  } catch (error) {
    yield put(setServerErrorCheckout({}));
    const errorMessage = error?.[0]?.errorMessage;
    yield put(setServerErrorCheckout({ errorMessage, component: 'PAGE' }));
    return error;
  }
}

// eslint-disable-next-line sonarjs/cognitive-complexity, complexity
export function* submitShipping({
  isEmailSignUpAllowed,
  emailSignUp = {},
  emailAddress,
  address,
  phoneNumber,
  method,
  smsInfo,
  hasSetGiftOptions,
  giftServicesData = {},
  savingContactSection,
  submitButtonId,
  saveToAccount,
  setAsDefault,
}) {
  const isGuestUser = yield select(isGuest);
  const { emailSignUpTCP, emailSignUpGYM } = emailSignUp;
  yield put(setAddressError(null));
  const giftServicesFormData = savingContactSection
    ? giftServicesData
    : yield select(getGiftServicesFormData);
  const giftOptionRequestDTO = createGitOptionRequestDTO(giftServicesFormData, hasSetGiftOptions);
  const giftOptionDTO = giftOptionRequestDTO ? { giftOptionRequestDTO } : {};
  const isLoginV2FlowEnabled = yield select(getLoginV2FlowEnabled);
  const isInternationalPhoneNumberEnabled = yield select(getIsInternationalPhoneNumber);
  const shippingAddressDTO = createShippingAddressRequestDTO({
    ...address,
    phoneNumber,
    emailAddress,
    smsInfo,
    isLoginV2FlowEnabled,
    isInternationalPhoneNumberEnabled,
  });
  const billingDetails = yield select(getBillingValues);
  const { address: { addressId, addressLine1 } = {} } = billingDetails || {};
  const shippingMethodDto = {
    shippingMethod: {
      id: method?.shippingMethodId ? method?.shippingMethodId : '',
    },
  };
  const updateShippingRequestDto = {
    ...giftOptionDTO,
    ...shippingMethodDto,
    shippingAddressDTO,
    billingAddressAvlbl: !!(addressId || addressLine1),
  };
  if (saveToAccount !== undefined) {
    updateShippingRequestDto.saveAddressToProfile = saveToAccount;
  }
  if (setAsDefault !== undefined) {
    updateShippingRequestDto.preferred = setAsDefault;
  }
  const fromActionPaypal = parseBoolean(getSessionStorage('fromActionPaypal'));
  if (fromActionPaypal) {
    updateShippingRequestDto.fromAction = 'paypal';
    removeSessionStorage('fromActionPaypal');
  }
  try {
    if (checkUpdateShippingRequiredFields(updateShippingRequestDto)) {
      yield put(setIsUpdatingShipmentMethods(true));
      const res = yield call(updateShipping, updateShippingRequestDto, giftServicesFormData);
      const [shipment = {}] = res?.data?.updateShipping?.shipments;

      const store = res?.data?.updateShipping?.shipments?.filter((data) => {
        if (data?.shipmentId !== 'me' && data?.itemsCount > 0) {
          return data;
        }
        return null;
      });
      const [shipmentPickup = {}] = store;
      const normalizedPhoneNumberPickUp = shipmentPickup?.shippingAddress?.phone?.replace(
        /\D/g,
        ''
      );

      const normalizedPhoneNumber = shipment?.shippingAddress?.phone?.replace(/\D/g, '');

      let phoneNumberValue = normalizedPhoneNumber;
      const shipmentIdValue = shipment?.shipmentId;

      const orderType = yield select(getOrderType);
      const isMixedOrder = orderType === 'ECOM_MIX';

      const unsubscribedPhoneNumber =
        readCookie('unsubscribedPhoneNumber') === 'null'
          ? false
          : readCookie('unsubscribedPhoneNumber');
      const smsSubscriptionStatus = parseBoolean(readCookie('smsSubscriptionStatus')) || false;

      const isUSorCaCountryCode =
        shipment?.shippingAddress?.c_phoneCountryCode === '+1' ||
        shipment?.shippingAddress?.c_phoneCountryCode === null ||
        shipment?.shippingAddress?.c_phoneCountryCode === undefined;

      const isUSorCaCountryCodePickup =
        shipmentPickup?.shippingAddress?.c_phoneCountryCode === '+1' ||
        shipmentPickup?.shippingAddress?.c_phoneCountryCode === null ||
        shipmentPickup?.shippingAddress?.c_phoneCountryCode === undefined;

      const isSMSUpdatesSingleOptInEnabled = yield select(getSMSUpdatesSingleOptInEnabled);

      if (smsSubscriptionStatus && !isUSorCaCountryCode && isSMSUpdatesSingleOptInEnabled) {
        setCookie({
          key: 'smsSubscriptionStatus',
          value: false,
        });
        setCookie({
          key: 'subscribedPhoneNumber',
          value: null,
        });
      }
      const subscribedPhoneNumber = readCookie('subscribedPhoneNumber');
      const pickUpNumber = isUSorCaCountryCodePickup ? normalizedPhoneNumberPickUp : null;
      phoneNumberValue = !isUSorCaCountryCode && isMixedOrder ? pickUpNumber : phoneNumberValue;

      const subscribedNewPhoneNumber =
        (phoneNumberValue !== subscribedPhoneNumber &&
          phoneNumberValue !== unsubscribedPhoneNumber) ||
        (unsubscribedPhoneNumber &&
          phoneNumberValue !== unsubscribedPhoneNumber &&
          !smsSubscriptionStatus);

      if (subscribedNewPhoneNumber && isSMSUpdatesSingleOptInEnabled) {
        let smsResponse = yield call(getTransSmsSubscriptionStateSaga, phoneNumberValue);
        let smsSubscriptionState = smsResponse?.data?.getTransSmsSubscriptionState?.status;

        if (
          isMixedOrder &&
          !smsSubscriptionState &&
          normalizedPhoneNumberPickUp &&
          isUSorCaCountryCodePickup
        ) {
          smsResponse = yield call(getTransSmsSubscriptionStateSaga, normalizedPhoneNumberPickUp);
          smsSubscriptionState = smsResponse?.data?.getTransSmsSubscriptionState?.status;
          if (smsSubscriptionState) {
            phoneNumberValue = normalizedPhoneNumberPickUp;
          }
        }

        setCookie({
          key: 'smsSubscriptionStatus',
          value: smsSubscriptionState,
        });

        if (smsSubscriptionState) {
          setCookie({
            key: 'subscribedPhoneNumber',
            value: phoneNumberValue,
          });
          setCookie({
            key: 'unsubscribedPhoneNumber',
            value: null,
          });
        } else {
          setCookie({
            key: 'unsubscribedPhoneNumber',
            value: phoneNumberValue,
          });
        }

        const optimizedPayload = [
          {
            shipmentId: shipmentIdValue,
            c_vibesSmsPhoneNo: phoneNumberValue || '',
          },
        ];
        const numberChanged = subscribedPhoneNumber
          ? subscribedPhoneNumber !== phoneNumberValue
          : false;

        // call sms order updates api when number is changed but this also is subscribed, we need to send this new number to Vibes
        if (subscribedNewPhoneNumber && smsSubscriptionState && numberChanged) {
          yield put(setSMSUpdatesActn(optimizedPayload));
        }
      }

      addPerformanceMarksForSection(BILLING_FORM_VISIBLE);
      const { data: { updateShipping: updateShippingRes } = {} } = res;
      yield put(setIsUpdatingShipmentMethods(false));
      const refreshCouponOnSubmitShipping = yield select(getRefreshCouponOnSubmitShipping);
      yield call(processMutationNonCachedDataSaga, {
        payload: {
          respToProcess: updateShippingRes,
          isCheckoutFlow: true,
          ignoreCache: refreshCouponOnSubmitShipping,
        },
      });
    }
  } finally {
    yield put(setIsUpdatingShipmentMethods(false));
  }
  yield call(setAfterPayPaymentmethod);
  const isDefaultApplePayEnabled = yield select(getIsDefaultApplePayAbTest);
  const isExpressCheckoutEnabled = yield select(isExpressCheckout);
  const isDefaultAfterPay = yield select(checkDefaultAfterPayEnabled);
  const billingMethod = yield select(getPaymentId);
  const walletIsSet = yield call(isWalletSetUp);
  const isExtendedPreOrderForSpc = yield select(getIsExtendedPreOrderForSPC);
  const orderType = yield select(getOrderType);
  const pickUpContactPerson = yield select(getPickupValues);
  const isPickupSectionSaved = !isEmpty(pickUpContactPerson?.firstName);
  // eslint-disable-next-line no-nested-ternary
  const sectionSaved = orderType === 'ECOM_MIX' ? isPickupSectionSaved : true;
  const applePayDefault = yield select(BagPageSelectors.showApplePayDefault);
  const isEligibleForDefaultApplePay = isDefaultApplePayEligible(
    isDefaultApplePayEnabled,
    isExpressCheckoutEnabled,
    billingMethod,
    isDefaultAfterPay,
    walletIsSet,
    isExtendedPreOrderForSpc,
    sectionSaved,
    applePayDefault
  );
  if (isEligibleForDefaultApplePay) {
    yield put(BagPageActions.setPaymentMethod('APPLE_PAY'));
  }

  yield put(recalibrateSectionStates());
  yield put(setShowAddressVerification(false));
  yield put(setLoaderState(false));
  yield put(setSpcButtonLoader({ id: submitButtonId, isLoading: false }));

  const isVenmoInProgress = yield select(selectors.isVenmoPaymentInProgress);
  yield fork(callUpdateRTPS, 'SPC', '', '', isVenmoInProgress, address, phoneNumber, emailAddress);

  if (isEmailSignUpAllowed && (emailSignUpTCP || emailSignUpGYM)) {
    yield submitEmailSignup(emailAddress, { emailSignUpTCP, emailSignUpGYM });
  }

  if (!isGuestUser && saveToAccount) {
    yield call(getAddressList);
  }
}

export function* submitGiftServices() {
  try {
    const giftServicesFormData = yield select(getGiftServicesFormData);
    const sfsError = yield select(getSfsError);
    if (sfsError) {
      yield put(setSFSErrors(null));
      if (typeof window !== 'undefined') {
        window.localStorage.removeItem('sfsError');
      }
    }
    const giftOptionRequestDTO = createGitOptionRequestDTO(giftServicesFormData, true);
    const errorMappings = yield select(BagPageSelectors.getErrorMapping);

    const res = yield call(updateGiftServices, giftOptionRequestDTO, errorMappings);
    const { data: { addGiftOptionToBasket: addGiftOptionToBasketRes } = {} } = res;

    yield call(processMutationNonCachedDataSaga, {
      payload: {
        respToProcess: addGiftOptionToBasketRes,
        isCheckoutFlow: true,
        ignoreCache: true,
      },
    });
  } catch (error) {
    if (error?.errorCode === '_ERR_SFS_SHIPPING_NOT_ALLOWED') {
      yield put(setSFSErrors(error));
      setLocalStorage({ key: 'sfsError', value: JSON.stringify(error) });
    }
    logger.error(error);
  }
}

export function* submitBillingSection(action) {
  const isVenmoInProgress = yield select(selectors.isVenmoPaymentInProgress);
  const isAppleInProgress = yield select(selectors.isApplePaymentInProgress);
  const isAfterPayInProgress = yield select(selectors.getIsAfterPayInProgress);
  yield put(setLoaderState(true));
  if (isVenmoInProgress) {
    yield call(submitVenmoBilling, action);
  } else if (isAppleInProgress) {
    yield call(submitAppleBilling, action);
  } else if (isAfterPayInProgress) {
    yield call(submitAfterPayOnBilling, action);
  } else {
    yield call(submitBilling, action);
  }
  yield put(setLoaderState(false));
}

export function* submitShippingSection(action) {
  yield submitShippingSectionData(action, submitShipping);
}

export function* submitVerifiedAddress(action) {
  try {
    yield put(setLoaderState(true));
    yield submitVerifiedAddressData(action, submitShipping);
    yield put(setLoaderState(false));
  } catch (err) {
    yield put(setLoaderState(false));
  }
}

function* setFromDataIfNotEqual(action) {
  const {
    payload: { formName, field, value },
  } = action;
  const selector = formValueSelector(formName);
  const state = yield select();
  if (selector(state, field) !== value) {
    yield put(change(formName, field, value));
  }
}

export function* callEddService(payload) {
  const { zipCode, state, orderId, skuList, isEDD, isEditing, eddAllowedStatesArr } = payload;
  const isEDDAllowedState =
    eddAllowedStatesArr && eddAllowedStatesArr.length > 0
      ? eddAllowedStatesArr.indexOf(state) > -1
      : false;

  if (isEDD && skuList.length && !isEditing) {
    if (isEDDAllowedState) {
      yield put(
        getEddData({
          zipCode,
          state,
          orderId,
          skuList,
          ignoreCache: true,
        })
      );
    } else {
      yield put(resetEddData(true));
    }
  }
}

export function* fetchAddressFromMelissa({ payload }) {
  try {
    const {
      zipCodeValue,
      addressField1,
      addressField2,
      addressLine1,
      addressLine2,
      formName,
      formSection,
      shouldLoadShipmentMethods,
      orderId,
      skuData,
      isEDD,
      isEditing,
      eddAllowedStatesArr,
    } = payload;
    yield put(toggleZipCodeLoader(true));
    const { suggestedAddress } = yield call(verifyAddressData, { zip: zipCodeValue });
    yield put(
      change(formName, `${formSection ? 'address.' : ''}city`, suggestedAddress.city.trim() || '')
    );
    yield put(
      change(
        formName,
        `${formSection ? 'address.' : ''}state`,
        suggestedAddress.state.trim() || null
      )
    );
    if (shouldLoadShipmentMethods && suggestedAddress.state && suggestedAddress.state.trim()) {
      yield call(loadShipmentMethods, {
        formName,
        state: suggestedAddress?.state,
        city: suggestedAddress?.city,
        addressField1: addressField1 || addressLine1,
        addressField2: addressField2 || addressLine2,
        zipCode: zipCodeValue,
        country: getSiteIdInCaps(),
      });
      yield call(callEddService, {
        zipCode: zipCodeValue,
        state: suggestedAddress.state,
        orderId,
        skuList: skuData,
        isEDD,
        isEditing,
        eddAllowedStatesArr,
      });
    }
    yield put(toggleZipCodeLoader(false));
  } catch (err) {
    yield put(toggleZipCodeLoader(false));
  }
}

export function* CheckoutSaga() {
  yield takeLatest(CONSTANTS.INIT_CHECKOUT, initCheckout);
  yield takeLatest(CONSTANTS.INIT_CHECKOUT_SECTION_PAGE, initCheckoutSectionData);
  // yield takeLatest(CONSTANTS.INIT_SHIPPING_PAGE, initShippingData);
  // yield takeLatest(CONSTANTS.INIT_BILLING_PAGE, initBillingData);
  // yield takeLatest(CONSTANTS.INIT_REVIEW_PAGE, initReviewData);
  yield takeLatest(CONSTANTS.CHECKOUT_SUBMIT_VERIFIED_SHIPPING_ADDRESS, submitVerifiedAddress);
  yield takeLatest('INIT_INTL_CHECKOUT', initIntlCheckout);
  yield takeLatest('CHECKOUT_SET_CART_DATA', storeUpdatedCheckoutValues);
  yield takeLatest(CONSTANTS.SUBMIT_SHIPPING_SECTION, submitShippingSection);
  yield takeLatest(CONSTANTS.SUBMIT_BILLING_SECTION, submitBillingSection);
  yield takeLatest('CHECKOUT_SUBMIT_PICKUP_DATA', submitPickupSection);
  yield takeLatest(CONSTANTS.CHECKOUT_LOAD_SHIPMENT_METHODS, loadShipmentMethods);
  yield takeLatest(CONSTANTS.ROUTE_TO_PICKUP_PAGE, routeToPickupPage);
  yield takeLatest(
    CONSTANTS.CHECKOUT_UPDATE_SHIPMENT_METHOD_SELECTION,
    updateShipmentMethodSelection
  );
  yield takeLatest(CONSTANTS.UPDATE_SHIPPING_ADDRESS, updateShippingAddress);
  yield takeLatest(CONSTANTS.ADD_NEW_SHIPPING_ADDRESS, addNewShippingAddress);
  yield takeLeading(CONSTANTS.SUBMIT_REVIEW_SECTION, submitOrderForProcessing);
  yield takeLatest(CONSTANTS.GET_VENMO_CLIENT_TOKEN, getVenmoClientTokenSaga);
  yield takeLatest(CONSTANTS.SET_SMS_UPDATES_CHECK, setSMSUpdatesSaga);
  yield takeLatest(CONSTANTS.GET_TRANS_SMS_SUBSCRIPTION_STATE, getTransSmsSubscriptionStateSaga);
  yield takeLatest(CONSTANTS.GET_APPLE_CLIENT_TOKEN, getAppleClientTokenSaga);
  yield takeLatest(CONSTANTS.FETCH_PAY_SECURE_SESSION_ID, fetchPaySecureSessionIdSaga);
  yield takeLatest(CONSTANTS.UPDATE_CARD_DATA, updateCardDetails);
  yield takeLatest(CONSTANTS.SUBMIT_ACCEPT_DECLINE_PLCC_OFFER, submitAcceptOrDeclinePlccData);
  yield takeEvery(CONSTANTS.SET_FROM_DATA_IF_NOT_EQUAL, setFromDataIfNotEqual);
  yield takeLatest(CONSTANTS.FETCH_ZIP_CODE_SUGGESTED_ADDRESS, fetchAddressFromMelissa);
  yield takeLatest(CONSTANTS.CALL_PERSIST_EDD, triggerEddPersist);
  yield takeLatest(CONSTANTS.CHECKOUT_WITH_AFTERPAY, checkoutWithAfterPay);
  yield takeLatest(CONSTANTS.CHECKOUT_WITH_EXPRESS_AFTERPAY, checkoutWithExpressAfterPay);
  yield takeLatest(CONSTANTS.SUBMIT_GIFT_SERVICES, submitGiftServices);
}
export default CheckoutSaga;
